// @ts-expect-error no valid declaration file available
import Tooltip from 'bootstrap/js/src/tooltip';
import { uuid } from './general';

function navigationObserver(): void {
  document.querySelectorAll('nav.navbar li[href]:not(.hide-click):not(.dropdown-toggle):not(.dropdown), nav.navbar a[href]:not(.hide-click):not(.dropdown-toggle):not(.dropdown), nav.navbar li[routerLink]:not(.hide-click), nav.navbar li[routerLinkActive]:not(.hide-click):not(.dropdown-toggle):not(.dropdown), nav.navbar a.dropdown-item[href]:not(.hide-click), nav.navbar a.dropdown-item[routerLink]:not(.hide-click), nav.navbar a.dropdown-item[routerLinkActive]:not(.hide-click):not(.dropdown-toggle):not(.dropdown), nav.navbar a.dropdown-item[href]:not(.hide-click), nav.navbar a.dropdown-item[routerLink]:not(.hide-click), nav.navbar a.nav-link[routerLinkActive]:not(.hide-click):not(.dropdown-toggle):not(.dropdown)').forEach((navbarLinkItem) => {
    navbarLinkItem.classList.add('hide-click');
    navbarLinkItem.addEventListener('click', () => (document.querySelector('button.navbar-toggler[aria-expanded="true"]') as HTMLButtonElement | null)?.click());
  });

  document.querySelectorAll('.side-menu:not([aria-label])').forEach(
    (sideMenu) => {
      if (sideMenu.tagName !== 'NAV') {
        sideMenu.role = 'navigation';
      }
      sideMenu.ariaLabel = 'Bereiche';
      (sideMenu as HTMLElement).tabIndex = -1;
    }
  );

  document.querySelectorAll('.side-menu:not(.no-collapse) ul.list-group:not(.initiated)').forEach((sideMenuListItem) => {
    const sideMenuItem = sideMenuListItem.parentElement;
    if (!sideMenuItem) {
      return;
    }

    if (!sideMenuItem.id) {
      sideMenuItem.id = uuid();
    }
    const toggleButton = document.createElement('button');
    toggleButton.classList.add('list-group-item', 'list-group-item-action', 'pointer', 'side-toggle-button');
    toggleButton.innerHTML = '<span class="side-menu-icon icon-open"><i class="fas fa-angle-double-right" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="right" title="Ausklappen" data-bs-boundary="body"></i></span><span class="side-menu-icon icon-close"><i class="fas fa-angle-double-left"></i></span><span class="side-menu-text">Einklappen</span>';
    toggleButton.addEventListener('click', () => {
      sideMenuItem.classList.toggle('open');
      toggleButton.ariaExpanded = sideMenuItem.classList.contains('open').toString();
    });
    toggleButton.ariaExpanded = sideMenuItem.classList.contains('open').toString();
    toggleButton.setAttribute('aria-controls', sideMenuItem.id);

    const listElement = document.createElement('li');
    listElement.classList.add('d-xl-none');
    listElement.insertBefore(toggleButton, null);

    sideMenuListItem.insertBefore(listElement, sideMenuListItem.childNodes[0]);
    sideMenuListItem.classList.add('initiated');
  });

  document.querySelectorAll('.side-menu.no-collapse:not(.resize-listener)').forEach((sideMenu) => {
    sideMenu.classList.add('resize-listener');
    new ResizeObserver(resizeObserver).observe(sideMenu);
    resizeObserver();
  });

  document.querySelectorAll('.side-menu a.list-group-item.list-group-item-action:not(.side-action-click):not(.side-toggle-button)').forEach((sideMenuActionItem) => {
    sideMenuActionItem.addEventListener('click', (event) => {
      let element = event.currentTarget as HTMLElement | null;
      while (element?.parentElement && element.parentElement !== document.body && !(element.parentElement instanceof Window)) {
        element = element.parentElement;
        if (element?.classList?.contains('side-menu')) {
          element.classList.remove('open');
          break;
        }
      }
    });
    sideMenuActionItem.classList.add('side-action-click');

    const iconElement = sideMenuActionItem.querySelector('span.side-menu-icon i:not(.tooltip-initiated)') as HTMLSpanElement | null;
    const textElement = sideMenuActionItem.querySelector('span.side-menu-text') as HTMLSpanElement | null;
    if (iconElement?.classList && textElement) {
      const actionName = textElement.innerText;
      if (actionName) {
        iconElement.title = actionName;
        iconElement.classList.add('tooltip-initiated');
        new Tooltip(iconElement, {
          toggle: 'tooltip',
          placement: 'right',
          trigger: 'hover',
          boundary: document.body
        });
      }
    }
  });

  if (document.querySelectorAll('.side-menu').length) {
    document.body?.classList?.add('contains-side-menu');
  } else if (document.body) {
    document.body?.classList?.remove('contains-side-menu');
  }

  if (document.querySelectorAll('form.top-search').length) {
    document.body?.classList?.add('contains-top-search');
  } else if (document.body) {
    document.body?.classList?.remove('contains-top-search');
  }

  if (document.querySelectorAll('.nav-secondary-bar').length) {
    document.body?.classList?.add('contains-nav-secondary-bar');
  } else if (document.body) {
    document.body?.classList?.remove('contains-nav-secondary-bar');
  }

  document.querySelectorAll('[data-bs-toggle="collapse"][data-bs-target]:not([aria-controls])').forEach(
    (collapseControl) => {
      collapseControl.setAttribute('aria-controls', collapseControl.getAttribute('data-bs-target')?.replace('#', '') ?? '');
      const contentElement = document.getElementById(collapseControl.getAttribute('aria-controls') ?? '');
      (collapseControl as HTMLElement).ariaExpanded = contentElement?.classList?.contains('show').toString() ?? null;
    }
  );

  document.querySelectorAll('nav.navbar:not([aria-label])').forEach(
    (togglerButton) => {
      togglerButton.ariaLabel = 'Hauptmenü';
    }
  );

  document.querySelectorAll('nav.navbar button.navbar-toggler:not([aria-label])').forEach(
    (togglerButton) => {
      togglerButton.ariaLabel = 'Hauptmenü ausklappen und einklappen';
    }
  );

  document.querySelectorAll('nav.nav-secondary-bar:not([aria-label]), .nav-secondary-bar nav:not([aria-label])').forEach(
    (togglerButton) => {
      togglerButton.ariaLabel = 'Unterseiten';
    }
  );

  document.querySelectorAll('.side-menu-icon:not([role])').forEach(
    (navigationIcons) => {
      navigationIcons.role = 'presentation';
    }
  );

  document.querySelectorAll('[data-bs-toggle="dropdown"]:not([aria-haspopup])').forEach(
    (collapseControl) => {
      collapseControl.ariaHasPopup = 'true';
      collapseControl.ariaExpanded = 'false';
      if (collapseControl.tagName !== 'button') {
        collapseControl.role = 'button';
      }
    }
  );

  (document.querySelectorAll('.dropdown-menu-overflow-scroll:not(.dropdown-menu-overflow-scroll-initiated)') as unknown as HTMLElement[]).forEach(
    (dropdownMenu) => {
      dropdownMenu.classList.add('dropdown-menu-overflow-scroll-initiated');
      const controlElementId = dropdownMenu.getAttribute('aria-labelledby');
      if (!controlElementId) {
        return;
      }

      const controlElement = document.getElementById(controlElementId);
      if (!controlElement) {
        return;
      }

      controlElement.addEventListener('click', () => {
        dropdownMenu.style.maxHeight = (window.innerHeight - dropdownMenu.getBoundingClientRect().top) + 'px';
      });
    }
  );

  document.querySelectorAll('.btn-close:not([aria-label])').forEach(
    collapseControl => collapseControl.ariaLabel = 'Schließen'
  );

  document.querySelectorAll('a[href]:not([tabindex])').forEach(
    navLink => (navLink as HTMLLinkElement).tabIndex = 0
  );

  document.querySelectorAll('[role="button"]:not([tabindex])').forEach(
    button => (button as HTMLElement).tabIndex = 0
  );

  document.querySelectorAll('i.fa-solid:not([role]):not([aria-hidden]), i.fa-regular:not([role]):not([aria-hidden]), i.fa-brands:not([role]):not([aria-hidden]), i.fas:not([role]):not([aria-hidden]), i.far:not([role]):not([aria-hidden]), i.fab:not([role]):not([aria-hidden])').forEach(
    icon => icon.role = 'presentation'
  );
}

function navigationClassObserver(): void {
  document.querySelectorAll('a[aria-current]:not(.active), .nav-item:not(.active) a[aria-current]').forEach(
    navLink => navLink.ariaCurrent = null
  );
  document.querySelectorAll('a.active[href]:not([aria-current]), .nav-item.active a[href]:not([aria-current])').forEach(
    navLink => navLink.ariaCurrent = 'page'
  );

  document.querySelectorAll('a[aria-disabled]:not(.disabled)').forEach(
    navLink => navLink.ariaDisabled = null
  );
  document.querySelectorAll('a.disabled:not([aria-disabled])').forEach(
    navLink => navLink.ariaDisabled = 'true'
  );
}

function resizeObserver(): void {
  const sideMenu = document.querySelector('.side-menu.no-collapse') as HTMLElement | null;
  if (sideMenu?.offsetWidth !== undefined) {
    document.body.style.paddingLeft = sideMenu.offsetWidth + 'px';
  } else {
    document.body.style.removeProperty('padding-left');
  }
  const secondaryNavbar = document.querySelector('.nav-secondary-bar') as HTMLElement | null;
  if (secondaryNavbar?.offsetWidth !== undefined) {
    secondaryNavbar.style.left = (sideMenu?.offsetWidth ?? 0) + 'px';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  navigationObserver();

  document.body.addEventListener('click', (event) => {
    let element = event.target as HTMLElement | null;
    const navbar = document.querySelector('nav.navbar');
    const sideMenu = document.querySelector('.side-menu');
    let navClick = false;
    let sideMenuClick = false;
    while (element?.parentElement && element.parentElement !== document.body && !(element.parentElement instanceof Window)) {
      element = element.parentElement;
      if (element === navbar) {
        navClick = true;
        break;
      }
      if (element === sideMenu) {
        sideMenuClick = true;
        break;
      }
    }

    if (!navClick) {
      (document.querySelector('button.navbar-toggler[aria-expanded="true"]') as HTMLButtonElement | null)?.click();
    }
    if (!sideMenuClick) {
      document.querySelectorAll('.side-menu').forEach((sideMenuItem) => {
        sideMenuItem.classList.remove('open');
      });
    }
  });

  new MutationObserver(navigationObserver).observe(document, { childList: true, subtree: true });
  new MutationObserver(navigationClassObserver).observe(document, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
});
